import { Component, TemplateRef } from '@angular/core';
import { ToastService } from '../../../../services/UI/toast.service'; // Adjust the path as needed

@Component({
  selector: 'app-toast-container',
  template: `
    <ngb-toast
      *ngFor="let toast of toastService.toasts"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      [class]="toast.classname"
      (hidden)="toastService.remove(toast)">
      <i *ngIf="toast.icon" class="{{ toast.icon }}"></i>&nbsp;
      <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
      </ng-template>

      <ng-template #text>{{ toast.textOrTpl }}</ng-template>
    </ngb-toast>
  `,
  host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast: any) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
